import { Component } from '@angular/core';

@Component({
  selector: 'admin-form-sizing-demo',
  templateUrl: './form-sizing-demo.component.html',
  styleUrls: ['./form-sizing-demo.component.scss'],
})
export class FormSizingDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/form/control/form-sizing/form-sizing-demo.component.ts